import { ArrowRight, Gift, ShoppingBag, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const highlights = [
  { icon: Sparkles, text: "20 pts offerts à l'inscription" },
  { icon: ShoppingBag, text: "1 pt par € dépensé" },
  { icon: Gift, text: "4 bons à gagner, de 5 à 20 €" },
];

export default function LoyaltySection() {
  return (
    <section id="fidelite" aria-labelledby="loyalty-title" className="loyalty-band py-12 lg:py-16">
      <div className="container mx-auto grid items-center gap-8 px-4 lg:grid-cols-[1.2fr_1fr] lg:gap-16 lg:px-8">
        <div>
          <p className="loyalty-ink mb-3 flex items-center gap-2 text-sm font-semibold"><Gift className="h-4 w-4" aria-hidden="true" />Les avantages Wememberz</p>
          <h2 id="loyalty-title" className="font-display text-3xl font-bold leading-tight md:text-4xl">Vos souvenirs méritent<br className="hidden sm:block" /> aussi des récompenses.</h2>
          <p className="mt-4 max-w-lg text-base leading-relaxed text-muted-foreground">Parrainez vos proches, cumulez des points et transformez-les en codes promo pour vos prochains albums.</p>
          <div className="mt-5 flex flex-col gap-2.5 text-sm font-medium">
            {highlights.map(({ icon: Icon, text }) => (
              <span key={text} className="flex items-center gap-2"><Icon className="h-4 w-4 shrink-0 loyalty-ink" aria-hidden="true" />{text}</span>
            ))}
          </div>
          <p className="mt-4 max-w-lg text-sm leading-relaxed text-muted-foreground">Et ce n'est pas tout : parrainer un proche, nous suivre sur les réseaux, fêter votre anniversaire… plein de petites actions font grimper votre compteur en un rien de temps.</p>
          <Button asChild variant="outline" className="mt-6 border-foreground/20 bg-background">
            <Link to="/programme-fidelite">Voir plus <ArrowRight aria-hidden="true" /></Link>
          </Button>
        </div>
        <img src="/images/hero/loyalty-friends.jpg" alt="Deux amies partagent leurs souvenirs autour d’un album photo" width={1536} height={1024} loading="lazy" className="aspect-[16/9] w-full rounded-lg object-cover object-right" />
      </div>
    </section>
  );
}